import { Box } from "@mui/material"
import Contact from "../container/Contact"
import Header from "../container/Header"
import Clients from "../components/Clients"
import Images from "../components/Images"
import Media from "../container/Media"
// import SocialMedia from "../components/SocialMedia"

const Home = () => {
  return (
    <Box sx={{
      width: "100%",
      backgroundColor: "#0a0a0a",
      color: "#fff",
      // maxWidth: "1440px", 
      px: {xs: "7vw", sm:"10vw"}, 
      margin: "0 auto",
    }}>
      <Header />
      <Media />
      <Clients />
      <Contact />
      {/* <Images /> */}
    </Box>
  )
}

export default Home